import IconsMap from '@internal/constants/IconsMap';
import DrawerMenu from '@internal/constants/DrawerMenu';

export {IconsMap, DrawerMenu};
